export default function ClinicsDoctor() {
  const tabsBtn = document.querySelectorAll('.clinics_doctor .slider-block .slider-heads .tabs-container .tab');

  if (tabsBtn) {
    tabsBtn.forEach((tab) => {
      tab.addEventListener('click', function (e) {
        const slider = document.querySelector(`#${this.dataset.tab}`);
        if (!slider) {
          return;
        }
        const parentSection = this.closest('section');
        const showSlider = parentSection.querySelector('.show-slider');
        if (showSlider) {
          showSlider.classList.remove('show-slider');
        }
        parentSection.querySelector('.tab-active').classList.remove('tab-active');
        this.classList.add('tab-active');
        slider.classList.add('show-slider');
      });
    });
  }
}
